import { useAtomValue } from 'jotai';

import { useTranslate } from '@growtherapy/i18n';

import { ChatDrawerWrapper as ChatDrawer } from '../../components';
import { TrackingEvents, sendLoggingEvents } from '../../events';
import { isChatErrorAtom } from '../../session';
import {
  currentConversationAtom,
  currentConversationMessagesAtom,
  currentConversationParticipantNamesAtom,
} from '../../session/state';
import { connectedAtAtom } from '../../video-sdk';
import { twilioIdentityAtom } from '../../video-sdk/twilio';
import { VisitorState, doesClientRequireSafetyGuardsAtom, visitorStateAtom } from '../state';

export function ChatDrawerWrapper() {
  const t = useTranslate();
  const chatName = useAtomValue(currentConversationParticipantNamesAtom).join(', ');
  const conversation = useAtomValue(currentConversationAtom);
  const messages = useAtomValue(currentConversationMessagesAtom);
  const identity = useAtomValue(twilioIdentityAtom);
  const connectedAt = useAtomValue(connectedAtAtom);
  const visitorState = useAtomValue(visitorStateAtom);
  const isChatError = useAtomValue(isChatErrorAtom);
  const doesClientRequireSafetyGuards = useAtomValue(doesClientRequireSafetyGuardsAtom);
  const sendMessage = (message: string) => {
    sendLoggingEvents(TrackingEvents.ANY_MESSAGE_SEND);
    sendLoggingEvents(TrackingEvents.CLIENT_MESSAGE_SEND);
    if (visitorState === VisitorState.MEETING) {
      sendLoggingEvents(TrackingEvents.ANY_SESSION_MESSAGE_SEND);
    }
    if (visitorState === VisitorState.WAITING) {
      sendLoggingEvents(TrackingEvents.ANY_WAITING_ROOM_MESSAGE_SEND);
    }
    conversation?.sendMessage(message);
  };
  const footerText = !connectedAt ? t('telehealth-core:chatDrawer.yourProviderMayBeInASession') : undefined;

  return (
    <ChatDrawer
      chatName={chatName}
      identity={identity}
      messages={messages}
      isError={isChatError}
      onSend={sendMessage}
      connectedAt={connectedAt}
      footerText={footerText}
      warningBannerText={
        doesClientRequireSafetyGuards
          ? t('telehealth-core:chatDrawer.parentsAndGuardiansMayProvideInformation')
          : undefined
      }
    />
  );
}
